import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useToaster } from '../components/Toaster';
import { loginFailure, clearUserError } from '../redux/slices/userSlice';
import styles from "./Login.module.css";

export default function Login() {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user);
  const isLoading = !!user.loading;
  const { push } = useToaster();
  const REDIRECT_URI = `${window.location.origin}/oauth2/callback/`;

  useEffect(() => {
    const e = user.error;

    if (e) {
      push({ title: '登入失敗', message: e, variant: 'danger' });
      dispatch(clearUserError());
    }
  }, [user.error, push, dispatch]);

  const loginWithCodeRedirect = useGoogleLogin({
    flow: 'auth-code',
    ux_mode: 'redirect',
    redirect_uri: REDIRECT_URI,
    onError: () => dispatch(loginFailure('Google 視窗被攔截或關閉')),
  });

  const onClick = () => {
    if (!isLoading) loginWithCodeRedirect();
  };

  return (
      <div className={`row ${styles.wrap}`}>
        <div className="col-12">
          <div className={styles.panel}>
            <header className={styles.header}>
              <h5 className={styles.title}>
                <span className={styles.badge}>SYSTEM</span>
                <span className={styles.titleText}>系統登入</span>
              </h5>
              <p className={styles.subtitle}>WELCOME TO USE</p>
            </header>

            <div className={styles.copy}>
              <p className="mb-1 mt-2">這段放的是歡迎回來說明文字：</p>
              <ul className={styles.list}>
                <li>登入後開始使用</li>
                <li>免費帳戶有使用限制</li>
              </ul>
            </div>

            <div className={styles.actions}>
              <button
                type="button"
                onClick={onClick}
                disabled={isLoading}
                aria-disabled={isLoading}
                aria-busy={isLoading}
                className={styles.googleBtn}
              >
                {isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className={styles.spinner}
                      disabled={true}
                    />
                    登入中…
                  </>
                ) : (
                  <>
                    <span className={styles.gDisc} aria-hidden="true">G</span>
                    使用 Google 登入
                  </>
                )}
              </button>

              <div className={styles.hint}>
                <span className={styles.dot} />
                開發測試中，若有 bug 敬請見諒
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}
